import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetPersonalInformation = createAsyncThunk(
  "PersonalInformation/GetPersonalInformation",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PersonalInformation/GetPersonalInformationData",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PersonalInformation = createSlice({
  name: "PersonalInformation",
  initialState: {
    PersonalInformation: {},
    loadingPersonalInformation: false,
    errorPersonalInformation: null,
  },
  reducers: {
    SetPersonalInformation: (state, action) => {
      state.PersonalInformation = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetPersonalInformation.pending, (state, action) => {
        state.loadingPersonalInformation = true;
        state.PersonalInformation = action.payload;
        state.errorPersonalInformation = null;
      })
      .addCase(GetPersonalInformation.fulfilled, (state, action) => {
        state.loadingPersonalInformation = false;
        state.PersonalInformation = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetPersonalInformation.rejected, (state, action) => {
        state.loadingPersonalInformation = false;
        state.errorPersonalInformation = action.payload;
      });
  },
});

export const { SetPersonalInformation } = PersonalInformation.actions;

export default PersonalInformation.reducer;
